(() => {
  const initialize = () => {
    document.querySelectorAll('[data-drop03-signup]').forEach((form) => {
      if (form.dataset.bound) return;
      form.dataset.bound = 'true';
      const email = form.querySelector('input[type="email"]');
      const button = form.querySelector('button[type="submit"]');
      const status = form.querySelector('[role="status"]');
      const error = form.querySelector('[role="alert"]');
      const fallback = form.querySelector('.d3-launch__fallback');
      const originalLabel = button.textContent;
      form.addEventListener('submit', async (event) => {
        event.preventDefault();
        if (form.dataset.submitting === 'true' || form.dataset.complete === 'true') return;
        if (!form.reportValidity()) return;
        error.hidden = true;
        status.hidden = true;
        fallback.hidden = true;
        email.removeAttribute('aria-invalid');
        email.setAttribute('aria-describedby', form.id + '-consent');
        form.dataset.submitting = 'true';
        form.setAttribute('aria-busy', 'true');
        button.disabled = true;
        button.textContent = form.getAttribute('data-pending');
        const controller = new AbortController();
        const timer = setTimeout(() => controller.abort(), 15000);
        try {
          const response = await fetch('https://a.klaviyo.com/client/subscriptions/?company_id=TUvmkS', {
            method: 'POST',
            headers: { 'Content-Type': 'application/vnd.api+json', revision: '2026-07-15' },
            signal: controller.signal,
            body: JSON.stringify({
              data: {
                type: 'subscription',
                attributes: {
                  custom_source: 'Drop 03 preview — ' + form.dataset.position,
                  profile: {
                    data: {
                      type: 'profile',
                      attributes: {
                        email: email.value.trim(),
                        properties: { drop_03_interest: true, drop_03_signup_placement: form.dataset.position },
                        subscriptions: { email: { marketing: { consent: 'SUBSCRIBED' } } }
                      }
                    }
                  }
                },
                relationships: { list: { data: { type: 'list', id: 'UvvpNY' } } }
              }
            })
          });
          if (!response.ok) {
            const failure = new Error('Subscription request failed');
            failure.status = response.status;
            throw failure;
          }
          form.dataset.complete = 'true';
          form.querySelector('.d3-launch__controls').hidden = true;
          form.querySelector('label').hidden = true;
          status.textContent = form.dataset.success;
          status.hidden = false;
          status.focus();
        } catch (failure) {
          form.dataset.lastError = String(failure.status || failure.name || 'network');
          error.textContent = failure.status === 429 ? form.dataset.rateLimit : form.dataset.error;
          error.hidden = false;
          fallback.hidden = false;
          if (failure.status === 400) {
            email.setAttribute('aria-invalid', 'true');
            email.setAttribute('aria-describedby', form.id + '-consent ' + error.id);
          }
          error.focus();
        } finally {
          clearTimeout(timer);
          form.dataset.submitting = 'false';
          form.removeAttribute('aria-busy');
          button.disabled = false;
          button.textContent = originalLabel;
        }
      });
    });
  };
  initialize();
  document.addEventListener('shopify:section:load', initialize);
})();
